export default [
  {
    path: "/document/preciousmetalmutualcover",
    name: "preciousMetalMutualCover",
    component: () =>
      import("@/views/document/preciousMetalMutualCover/index.vue"),
    meta: {
      pageTitle: "PreciousMetalMutualCover",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalMutualCover",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalmutualcover/edit/id=:id",
    name: "EditPreciousMetalMutualCover",
    component: () =>
      import("@/views/document/preciousMetalMutualCover/edit.vue"),
    meta: {
      pageTitle: "PreciousMetalMutualCover",
      navActiveLink: "preciousMetalMutualCover",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalMutualCover",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalmutualcover/view/id=:id",
    name: "ViewPreciousMetalMutualCover",
    component: () =>
      import("@/views/document/preciousMetalMutualCover/view.vue"),
    meta: {
      pageTitle: "PreciousMetalMutualCover",
      navActiveLink: "preciousMetalMutualCover",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalMutualCover",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalrate",
    name: "preciousmetalrate",
    component: () => import("@/views/document/preciousmetalrate/index.vue"),
    meta: {
      pageTitle: "PreciousMetalRate",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalRate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalrate/edit/id=:id",
    name: "EditPreciousMetalRate",
    component: () => import("@/views/document/preciousmetalrate/edit.vue"),
    meta: {
      pageTitle: "PreciousMetalRate",
      navActiveLink: "preciousmetalrate",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalRate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalrate/view/id=:id",
    name: "ViewPreciousMetalRate",
    component: () => import("@/views/document/preciousmetalrate/view.vue"),
    meta: {
      pageTitle: "PreciousMetalRate",
      navActiveLink: "preciousmetalrate",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalRate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalratetemplate",
    name: "preciousmetalratetemplate",
    component: () =>
      import("@/views/document/preciousmetalratetemplate/index.vue"),
    meta: {
      pageTitle: "PreciousMetalRateTemplate",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalRateTemplate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalratetemplate/edit/id=:id",
    name: "EditPreciousMetalRateTemplate",
    component: () =>
      import("@/views/document/preciousmetalratetemplate/edit.vue"),
    meta: {
      pageTitle: "PreciousMetalRateTemplate",
      navActiveLink: "preciousmetalratetemplate",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalRateTemplate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalratetemplate/view/id=:id",
    name: "ViewPreciousMetalRateTemplate",
    component: () =>
      import("@/views/document/preciousmetalratetemplate/view.vue"),
    meta: {
      pageTitle: "PreciousMetalRateTemplate",
      navActiveLink: "preciousmetalratetemplate",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalRateTemplate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalorder",
    name: "preciousmetalorder",
    component: () => import("@/views/document/preciousmetalorder/index.vue"),
    meta: {
      pageTitle: "PreciousMetalOrder",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalOrder",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalorder/edit/id=:id",
    name: "EditPreciousMetalOrder",
    component: () => import("@/views/document/preciousmetalorder/edit.vue"),
    meta: {
      pageTitle: "PreciousMetalOrder",
      navActiveLink: "preciousmetalorder",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalOrder",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalorder/view/id=:id",
    name: "ViewPreciousMetalOrder",
    component: () => import("@/views/document/preciousmetalorder/view.vue"),
    meta: {
      pageTitle: "PreciousMetalOrder",
      navActiveLink: "preciousmetalorder",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalOrder",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetaldeviceoperation",
    name: "preciousmetaldeviceoperation",
    component: () =>
      import("@/views/document/preciousmetaldeviceoperation/index.vue"),
    meta: {
      pageTitle: "PreciousMetalDeviceOperation",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalDeviceOperation",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetaldeviceoperation/view/id=:id",
    name: "ViewPreciousMetalDeviceOperation",
    component: () =>
      import("@/views/document/preciousmetaldeviceoperation/view.vue"),
    meta: {
      pageTitle: "PreciousMetalDeviceOperation",
      navActiveLink: "preciousmetaldeviceoperation",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalDeviceOperation",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalpurchase",
    name: "preciousmetalpurchase",
    component: () => import("@/views/document/preciousmetalpurchase/index.vue"),
    meta: {
      pageTitle: "PreciousMetalPurchase",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalPurchase",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalpurchase/view/id=:id",
    name: "ViewPreciousMetalPurchase",
    component: () => import("@/views/document/preciousmetalpurchase/view.vue"),
    meta: {
      pageTitle: "PreciousMetalPurchase",
      navActiveLink: "preciousmetalpurchase",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalPurchase",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalsell",
    name: "preciousmetalsell",
    component: () => import("@/views/document/preciousmetalsell/index.vue"),
    meta: {
      pageTitle: "PreciousMetalSell",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalSell",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashpreciousmetalsell",
    name: "cashpreciousmetalsell",
    component: () => import("@/views/document/cashpreciousmetalsell/index.vue"),
    meta: {
      pageTitle: "CashPreciousMetalSell",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CashPreciousMetalSell",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashpreciousmetalpurchase",
    name: "cashpreciousmetalpurchase",
    component: () =>
      import("@/views/document/cashpreciousmetalpurchase/index.vue"),
    meta: {
      pageTitle: "CashPreciousMetalPurchase",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CashPreciousMetalPurchase",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalsell/view/id=:id",
    name: "ViewPreciousMetalSell",
    component: () => import("@/views/document/preciousmetalsell/view.vue"),
    meta: {
      pageTitle: "PreciousMetalSell",
      navActiveLink: "preciousmetalsell",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalSell",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/gold/preciousmetaldevicesetting",
    name: "preciousmetaldevicesetting",
    component: () =>
      import("@/views/document/preciousmetaldevicesetting/index.vue"),
    meta: {
      pageTitle: "PreciousMetalDeviceSetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalDeviceSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/gold/preciousmetaldevicesetting/edit/id=:id",
    name: "EditPreciousMetalDeviceSetting",
    component: () =>
      import("@/views/document/preciousmetaldevicesetting/edit.vue"),
    meta: {
      pageTitle: "PreciousMetalDeviceSetting",
      navActiveLink: "preciousmetaldevicesetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalDeviceSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/gold/preciousmetaldevicesetting/view/id=:id",
    name: "ViewPreciousMetalDeviceSetting",
    component: () =>
      import("@/views/document/preciousmetaldevicesetting/view.vue"),
    meta: {
      pageTitle: "PreciousMetalDeviceSetting",
      navActiveLink: "preciousmetaldevicesetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalDeviceSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalordersetting",
    name: "preciousmetalordersetting",
    component: () =>
      import("@/views/document/preciousMetalOrderSetting/index.vue"),
    meta: {
      pageTitle: "PreciousMetalOrderSetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalOrderSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalordersetting/edit/id=:id",
    name: "EditPreciousMetalOrderSetting",
    component: () =>
      import("@/views/document/preciousMetalOrderSetting/edit.vue"),
    meta: {
      pageTitle: "PreciousMetalOrderSetting",
      navActiveLink: "preciousmetalordersetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalOrderSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/preciousmetalordersetting/view/id=:id",
    name: "ViewPreciousMetalOrderSetting",
    component: () =>
      import("@/views/document/preciousMetalOrderSetting/view.vue"),
    meta: {
      pageTitle: "PreciousMetalOrderSetting",
      navActiveLink: "preciousmetalordersetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PreciousMetalOrderSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashpreciousmetalinspection",
    name: "cashpreciousmetalinspection",
    component: () =>
      import("@/views/document/cashPreciousMetalInspection/index.vue"),
    meta: {
      pageTitle: "CashPreciousMetalInspection",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CashPreciousMetalInspection",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/pmdevicerequirement",
    name: "pmdevicerequirement",
    component: () => import("@/views/document/pmDeviceRequirement/index.vue"),
    meta: {
      pageTitle: "PMDeviceRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PMDeviceRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/pmdevicerequirement/create",
    name: "CreatePmDeviceRequirement",
    component: () => import("@/views/document/pmDeviceRequirement/edit.vue"),
    meta: {
      pageTitle: "PMDeviceRequirement",
      navActiveLink: "pmdevicerequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PMDeviceRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/pmdevicerequirement/edit/id=:id",
    name: "EditPmDeviceRequirement",
    component: () => import("@/views/document/pmDeviceRequirement/edit.vue"),
    meta: {
      pageTitle: "PMDeviceRequirement",
      navActiveLink: "pmdevicerequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PMDeviceRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/pmdevicerequirement/view/id=:id",
    name: "ViewPmDeviceRequirement",
    component: () => import("@/views/document/pmDeviceRequirement/view.vue"),
    meta: {
      pageTitle: "PMDeviceRequirement",
      navActiveLink: "pmdevicerequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "PMDeviceRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/document/cashpreciousmetalinspection/view/id=:id",
    name: "ViewCashPreciousMetalInspection",
    component: () =>
      import("@/views/document/cashPreciousMetalInspection/view.vue"),
    meta: {
      pageTitle: "CashPreciousMetalInspection",
      navActiveLink: "cashpreciousmetalinspection",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CashPreciousMetalInspection",
          active: true,
        },
      ],
    },
  },
]
